import { compactObject } from './_internal';

function resolveCountryCode(user) {
  return (user && user.countryCode) || (user && user.country_code);
}

function resolveIsMember(user) {
  if (user && user.isMember !== undefined) {
    return user.isMember;
  }
  return user && user.is_member;
}

function userGroupForSite(user, site) {
  if (typeof user?.userGroupForSite === 'function') {
    return user.userGroupForSite(site);
  }

  if (!user || !site || !Array.isArray(user.userGroups)) {
    return null;
  }

  return user.userGroups.find(item => item && item.group && item.group.siteId === site.id);
}

function resolveMembershipTypeId(user, site) {
  if (site && !site.isSeedlang) {
    return userGroupForSite(user, site)?.membershipTypeId;
  }

  if (user && user.membershipTypeId !== undefined) {
    return user.membershipTypeId;
  }
  return user && user.membership_type_id;
}

function resolveSiteName(site) {
  return (site && site.teamName) || (site && site.team_name) || (site && site.name);
}

export function isFrontendOnlyEvent(eventType) {
  return typeof eventType === 'string' && eventType.startsWith('memrev - ');
}

export function buildSharedEventProperties({ params = {}, user, site }) {
  return compactObject({
    ...params,
    is_member: params.is_member !== undefined ? params.is_member : resolveIsMember(user),
    membership_type_id: params.membership_type_id !== undefined ? params.membership_type_id : resolveMembershipTypeId(user, site),
    site_id: params.site_id !== undefined ? params.site_id : (site && site.id),
    site_name: params.site_name !== undefined ? params.site_name : resolveSiteName(site),
    country_code: params.country_code !== undefined ? params.country_code : resolveCountryCode(user),
  });
}

export function buildWebPosthogEventProperties({ eventType, params = {}, user, site }) {
  const baseParams = buildSharedEventProperties({ params, user, site });

  if (isFrontendOnlyEvent(eventType)) {
    return baseParams;
  }

  return {
    ...baseParams,
    platform: 'web',
  };
}
